<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="primary--text text-center mt-5">User Profile</h1>
      <v-text-field type="password" v-model="pwd"
        label="Current Password" @change="entryChanged=true"
      />
      <v-text-field type="password" v-model="newPwd"
        label="New Password" @change="entryChanged=true"
      />
      <v-text-field type="password" v-model="cnewPwd"
        label="Re-type New Password" @change="entryChanged=true"
      />
      <v-row>
        <v-btn color="error" outlined to="/">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="saveChange">Save Changes</v-btn>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'password',
  computed: {
    ...mapGetters([
      'userProfile',
    ])
  },
  data: () => ({
    pwd: '',
    cnewPwd: '',
    newPwd: '',
    entryChanged: false,
  }),
  methods: {
    saveChange() {
      if (!this.entryChanged) {
        return
      }
      if (this.pwd == '') {
        return alert('Enter Current Password')
      }
      if (this.newPwd == '') {
        return alert('Enter New Password')
      }
      if (this.newPwd != this.cnewPwd) {
        return alert('New Password and Re-type New Passsword are not identical')
      }
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token }
      var pass = {
        currUserPassword: this.pwd,
        userPassword: this.newPwd,
      }
      axios.post('/api/updatepwd', JSON.stringify(pass), { headers: header } )
      .then(() => {
        alert('Password has been changed')
      })
    }
  }
}
</script>